/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Sync inert attribute with aria-hidden on PhotoSwipe dialog
  var pswpEl = document.querySelector('.pswp');
  if (pswpEl) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'aria-hidden') {
          var hidden = pswpEl.getAttribute('aria-hidden') === 'true';
          if (hidden) {
            pswpEl.setAttribute('inert', '');
          } else {
            pswpEl.removeAttribute('inert');
          }
        }
      });
    }).observe(pswpEl, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  // Fix: Flickity aria-hidden slides still receive keyboard focus.
  // Sync inert attribute with aria-hidden on each Flickity cell so
  // focusable children inside hidden slides are unreachable by keyboard.
  function syncFlickityInert(flkty) {
    if (!flkty || !flkty.cells) return;
    flkty.cells.forEach(function(cell) {
      var el = cell.element;
      if (el.getAttribute('aria-hidden') === 'true') {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  }

  function attachFlickityListeners(container) {
    var Flickity = window.themeVendor && window.themeVendor.Flickity;
    var flkty = Flickity ? Flickity.data(container) : null;
    if (!flkty) return;
    flkty.on('settle', function() { syncFlickityInert(flkty); });
    flkty.on('select', function() { syncFlickityInert(flkty); });
    syncFlickityInert(flkty);
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Attach to carousels already in DOM
    document.querySelectorAll('.flickity-enabled').forEach(attachFlickityListeners);

    // Watch for dynamically initialised carousels
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('flickity-enabled')) {
            attachFlickityListeners(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.flickity-enabled').forEach(attachFlickityListeners);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

})();
